module.exports = __webpack_public_path__ + "static/icarus-13f8cf4fcf0abd4e6acc460c041b912f.jpg";